export const KIT_DASHBOARD_ROUTE = "/shops/kits";
export const KIT_ORDER_SETUP_RECIPIENT = "/shops/kit-orders/:number/recipients";
export const KIT_ORDER_SETUP_PREFERENCE = "/shops/kit-orders/:number/preferences";
export const KIT_ORDER_SETUP_EXPERIENCE = "/shops/kit-orders/:number/experience";
export const KIT_ORDER_SETUP_CUSTOMIZATION = "/shops/kit-orders/:number/customizations";
export const KIT_ORDER_SETUP_RECIPIENT_NOTE = "/shops/kit-orders/:number/recipient-note";
export const KIT_ORDER_SETUP_CHECKOUT = "/shops/kit-orders/:number/checkout";
export const SEND_ITEMS_ROUTE = `${KIT_DASHBOARD_ROUTE}?send-items=true`;

export const FORM_STATE_RECIPIENTS = "recipients";
export const FORM_STATE_CHECKOUT = "checkout";
export const FORM_STATE_CHOOSE_ITEMS = "choose-items";
export const FORM_STATE_CUSTOMIZATIONS = "customizations";
export const FORM_STATE_EXPERIENCE = "experience";
export const FORM_STATE_PREFERENCES = "preferences";
export const FORM_STATE_RECIPIENT_NOTE = "recipient-note";

export const KIT_TYPE_US = "us";
export const KIT_TYPE_GLOBAL = "global";

export const KIT_STATE_LIVE = "live";
export const KIT_STATE_DRAFT = "draft";
export const KIT_STATE_EXPIRED = "expired";

export const KIT_COLUMNS = [KIT_TYPE_US, KIT_TYPE_GLOBAL];

export const WAREHOUSE_ITEM = "warehouse";
export const ON_DEMAND_ITEM = "on_demand";

export const SHIPPED_FROM_STADIUM = "shippedFromStadium";
export const SHIPPED_SEPARATELY = "shippedSeparately";

export const getKitOrderedSteps = ({
  surprise = false,
  hasWarehouseProducts = true,
  excelUploadedForOrder = false,
}) => [
  FORM_STATE_CHOOSE_ITEMS,
  FORM_STATE_RECIPIENTS,
  ...(surprise && !excelUploadedForOrder ? [FORM_STATE_PREFERENCES] : []),
  ...(surprise ? [FORM_STATE_RECIPIENT_NOTE] : []),
  ...(surprise ? [] : [FORM_STATE_EXPERIENCE]),
  ...(hasWarehouseProducts ? [FORM_STATE_CUSTOMIZATIONS] : []),
  FORM_STATE_CHECKOUT,
];

export const KIT_ORDERED_STEPS_MAPPING = Object.freeze({
  [FORM_STATE_CHOOSE_ITEMS]: {
    key: FORM_STATE_CHOOSE_ITEMS,
    route: "",
    routeText: "CHOOSE ITEMS",
    stepNo: 0,
  },
  [FORM_STATE_RECIPIENTS]: {
    key: FORM_STATE_RECIPIENTS,
    route: KIT_ORDER_SETUP_RECIPIENT,
    routeText: "RECIPIENTS",
    stepNo: 1,
  },
  [FORM_STATE_PREFERENCES]: {
    key: FORM_STATE_PREFERENCES,
    route: KIT_ORDER_SETUP_PREFERENCE,
    routeText: "PREFERENCES",
    stepNo: 2,
  },
  [FORM_STATE_RECIPIENT_NOTE]: {
    key: FORM_STATE_RECIPIENT_NOTE,
    route: KIT_ORDER_SETUP_RECIPIENT_NOTE,
    routeText: "RECIPIENT NOTE",
    stepNo: 3,
  },
  [FORM_STATE_EXPERIENCE]: {
    key: FORM_STATE_EXPERIENCE,
    route: KIT_ORDER_SETUP_EXPERIENCE,
    routeText: "EXPERIENCE",
    stepNo: 4,
  },
  [FORM_STATE_CUSTOMIZATIONS]: {
    key: FORM_STATE_CUSTOMIZATIONS,
    route: KIT_ORDER_SETUP_CUSTOMIZATION,
    routeText: "CUSTOMIZATIONS",
    stepNo: 5,
  },
  [FORM_STATE_CHECKOUT]: {
    key: FORM_STATE_CHECKOUT,
    route: KIT_ORDER_SETUP_CHECKOUT,
    routeText: "CHECKOUT",
    stepNo: 6,
  },
});

export const MIN_GLOBAL_PRICE_PER_RECIPIENT = 100;
